import { GiCongress, GiPhone } from 'react-icons/gi';
import { MdRocketLaunch } from 'react-icons/md';
import { PiBuildingOffice } from 'react-icons/pi';
import { LuApple } from 'react-icons/lu';
import { IoPersonCircleOutline } from 'react-icons/io5';
import { MdLocalMovies } from 'react-icons/md';
import { DtType } from '../generated/graphql';
import { GoPeople } from 'react-icons/go';
import { FaMedal, FaUniversity } from 'react-icons/fa';

export const getIndustryDetails = (industry: DtType) => {
  const digitalTwinNames =
    industry === DtType.Congressperson
      ? ['Alexandria Ocasio-Cortez', 'Ted Cruz', 'Bernie Sanders']
      : industry === DtType.EarlyStageVcs
        ? ['Semil Shah', 'Michael Dempsey', 'Sunny Dhillon']
        : industry === DtType.FortuneCeos
          ? ['Satya Nadella', 'Elon Musk', 'Mary Barra']
          : industry === DtType.MoviesFull ||
              industry === DtType.MoviesSimple ||
              industry === DtType.MoviesMedium
            ? ['Jane Doe', 'John Doe']
            : industry === DtType.NycMayoralCandidate
              ? ['Eric Adams', 'Andrew Cuomo', 'Zohran Mamdani']
              : industry === DtType.FedMember
                ? ['Jerome Powell', 'Neel Kashkari', 'Mary Daly']
                : ['TODO'];
  let digitalTwinString = digitalTwinNames.join(', ');
  if (digitalTwinString.length > 36) {
    digitalTwinString = `${digitalTwinString.slice(0, 35)}...`;
  }

  const industryDetails =
    industry === DtType.Congressperson
      ? { title: 'Politics', icon: GiCongress }
      : industry === DtType.EarlyStageVcs
        ? { title: 'Venture Capital', icon: MdRocketLaunch }
        : industry === DtType.FortuneCeos
          ? { title: 'CEOs', icon: PiBuildingOffice }
          : industry === DtType.MoviesFull
            ? { title: 'Movies Survey (Full)', icon: MdLocalMovies }
            : industry === DtType.MoviesMedium
              ? { title: 'Movies Survey (Medium)', icon: MdLocalMovies }
              : industry === DtType.MoviesSimple
                ? { title: 'Movies Survey (Simple)', icon: MdLocalMovies }
                : industry === DtType.NycMayoralCandidate
                  ? { title: 'Local Politics', icon: LuApple }
                  : industry === DtType.Sendril
                    ? { title: 'Sendril Private Persona', icon: GoPeople }
                    : industry === DtType.Influencer
                      ? { title: 'Influencer', icon: GiPhone }
                      : industry === DtType.Model
                        ? { title: 'Model Evaluation', icon: FaMedal }
                        : industry === DtType.FedMember
                          ? { title: 'FOMC Members', icon: FaUniversity }
                          : { title: 'Collection', icon: IoPersonCircleOutline };
  return { twins: digitalTwinString, industryDetails };
};
